import { THEME_COLORS, SHADOWS, PROFILE_COLORS, AVATAR_COLORS, STATUS_COLORS, MODAL_COLORS, INTERACTIVE_COLORS } from './colors';

/* --- From login.ts --- */
export const COLORS = {
  bg: "linear-gradient(180deg, #010802 0%, #020A05 47.6%, #121F14 100%)",
  topbarBg: "linear-gradient(180deg, #010802f5 0%, #010802b8 70%, #01080200 100%)",
  iconColor: "#9CA3AF",
  borderColor: "#154617",
  selectedText: "#5FAB2E",
  bgDropdown: "#181F2F",
  borderDropdown: "#262B37",
  bgLanguageMenu: "#0f1629",
  iconGlobal: "#E5E7EB",
  line: "#6B7280",
  bgConnect: "linear-gradient(91deg, #344b21cc -1.21%, #296d26cc 60.35%, #c0c655cc 97.28%)",
  borderConnect: "#d7ff7033",
  shadowConnect: "0 2px 21px 0 #a4b3fc26",
  bgOther: "#35353533",
  walletIconGradientStart: "#A7BD32",
  walletIconGradientEnd: "#5FAB2E",
  orbText: "linear-gradient(180deg, #4C9130 13.16%, #FFF3BC 50.54%, #85BA42 85.96%)",
  lightYellow: "#FCFDFB",
  textShadow: "0 0 4px #FDDD55",
  bgWallet: "linear-gradient(102deg, #224c2a4d -1.54%, #113b1300 128.36%)",
  walletTrustBg: "#fff",
  walletMetaMaskBg: "linear-gradient(135deg, #FFFFFF 0%, #FFE8CC 55%, #F8B56A 100%)",
  walletConnectBg: "linear-gradient(135deg, #3B99FC 0%, #1F6BFF 100%)",
  oldUserBg: "linear-gradient(108.802deg, #224c2a1a 1.5365%, #113b1300 128.36%)",
  oldUserTop: "#4ACA61",
  oldUserBottom: "#3B8C31",
  oldUserArrow: "#18DCA0",
  oldUserButtonBg: "#010c2633",
  oldUserButtonBorder: "#BFD648",
  oldUserButtonText: "#C5CE28",
  loginBtnBg: "linear-gradient(91deg, #F5EC63 -1.21%, #FD9E1B 97.28%)",
  loginBtnText: "#1a1a0a",
  bottomFeatureBg: "#ffffff0d",
} as const;

export const REMEMBER_USERNAME_KEY = 'uo_remember_username';

export const HERO_IMAGE = "/092a739469e98b7545bc7b7477c2e6ee59326682.png";
export const TOPBAR_OFFSET = 76;

export const LOGIN_LINE_IDS = ['line1', 'line2', 'line3', 'line4'] as const;

export const SUPPORTED_WALLETS = [{
  id: 'trust',
  background: COLORS.walletTrustBg,
  iconSrc: '/brand/icons/wallets/trust-wallet.svg',
}, {
  id: 'metamask',
  background: COLORS.walletMetaMaskBg,
  iconSrc: '/brand/icons/wallets/metamask.svg',
}, {
  id: 'walletconnect',
  background: COLORS.walletConnectBg,
  iconSrc: '/brand/icons/wallets/walletconnect.svg',
}, {
  id: 'more',
  background: COLORS.bgOther,
},] as const;

export const LOGIN_FEATURES = [{
  id: 'secure',
  labelKey: 'auth.features.secure'
}, {
  id: 'decentralized',
  labelKey: 'auth.features.decentralized'
}, {
  id: 'fast',
  labelKey: 'auth.features.fast'
},] as const;

export const OLD_USER_METHODS = [{
  id: 'email',
  labelKey: 'auth.oldUserMethods.email.label',
  descKey: 'auth.oldUserMethods.email.desc',
}, {
  id: 'wallet',
  labelKey: 'auth.oldUserMethods.wallet.label',
  descKey: 'auth.oldUserMethods.wallet.desc',
}, {
  id: 'complete',
  labelKey: 'auth.oldUserMethods.complete.label',
  descKey: 'auth.oldUserMethods.complete.desc',
},] as const;

export interface LanguageOption {
  code: string;
  label: string;
  shortLabel: string;
}

export const AVAILABLE_LANGUAGES: LanguageOption[] = [
  { code: 'zh', label: '简体中文', shortLabel: '简体' },
  { code: 'en', label: 'English', shortLabel: 'EN' },
];

/* --- From me.ts --- */
export type MeItemDef = {
  key: string;
  color?: string;
  icon?: string;
  to?: string;
  isLogout?: boolean;
};


export const ME_COLORS = {
  ...THEME_COLORS,
  heroFade: 'linear-gradient(180deg, transparent 0%, transparent 55%, #010802 100%)',
  gold: STATUS_COLORS.warning,
  avatarFill: AVATAR_COLORS.fill,
  avatarLetter: AVATAR_COLORS.letter,
  avatarRingGradientStart: AVATAR_COLORS.ringGradientStart,
  avatarRingGradientEnd: AVATAR_COLORS.ringGradientEnd,
  metricDanger: AVATAR_COLORS.danger,
  playerIdShadow: SHADOWS.playerIdShadow,
  levelTrack: '#253029',
  levelFill: THEME_COLORS.levelFillGradient,
  levelTrackShadow: SHADOWS.levelTrackShadow,
  levelFillShadow: SHADOWS.levelFillShadow,
  inviteBorder: '#E3B933',
  inviteMask: 'linear-gradient(90deg, #000000 0%, #000000 62%, transparent 100%)',
  inviteEdgeBlur: 'rgb(2, 10, 4)',
  inviteCode: '#FCD749',
  inviteCodeShadow: SHADOWS.inviteCodeShadow,
  inviteActionBg: 'rgba(255,255,255,0.05)',
  modalOverlay: MODAL_COLORS.overlay,
  modalOverlayBlur: MODAL_COLORS.overlayBlur,
  modalBg: MODAL_COLORS.bg,
  modalBlur: MODAL_COLORS.blur,
  menuLineDefault: '#A7E768',
  menuLineShadow: SHADOWS.menuLineShadow,
  qrDark: '#000000',
  qrLight: '#FFFFFF',
} as const;

export const ME_ITEM_COLORS = PROFILE_COLORS;

export const ME_ABBR_BY_KEY: Record<string, string> = {
  'me_asset.sell_uo': 'ORB',    'me_asset.mp_to_uo': 'MP',
  'me_asset.ep_to_rp': 'RP',   'me_asset.ep1_to_ep': 'E1',
  'me_asset.ep2_to_ep': 'E2',  'me_asset.ep1_to_sp1': 'S1',
  'me_asset.rp_to_sp3': 'S3',
  'me_asset.sp3_to_sp1': 'S1',
  'me_asset.uoc_withdraw': 'UC',
  'me_asset.rp_withdraw': 'RP','me_asset.tp_withdraw': 'TP',
  'me_asset.rp_tp_fc': 'FC',   'me_asset.fp_withdraw': 'FP',
  'me_asset.fc_withdraw': 'FC',
  'me_asset.recharge_tp': 'TP',
  'me_asset.static_usdt_payout': 'USDT',
  'me_market.sub_accounts': 'SUB','me_market.nearby': 'NE',
  'me_market.all_users': 'GL', 'me_market.register_member': 'REG',
  'me_finance.ep_records': 'EP',   'me_finance.ep1_records': 'E1',
  'me_finance.ep2_records': 'E2',  'me_finance.rp_records': 'RP',
  'me_finance.sp1_records': 'S1',  'me_finance.sp2_records': 'S2',
  'me_finance.sp3_records': 'S3',  'me_finance.mp_records': 'MP',
  'me_finance.uoc_records': 'UC',  'me_finance.fp_records': 'FP',
  'me_finance.tp_records': 'TP',   'me_finance.uo_records': 'ORB',
  'me_finance.fc_records': 'FC',   'me_finance.activation_records': 'ACT',
  'me_finance.uoc_mint_records': 'MNT','me_finance.uoc_withdraw_records': 'OUT',
  'me_finance.income_details': 'INC','me_finance.ep_purchase_records': 'BUY',
  'me_finance.fork_records': 'FK', 'me_finance.donate': 'DN',
  'me_finance.imputation': 'IM',
  'me_system.exchange_calc': 'FX',
  'me_system.feedback': 'FB',
  'me_system.google_auth': 'G',
  'me_system.complaints': 'CP',
  'me_system.kyc': 'KYC',
  'me_system.honor': 'HN',
  'me_system.settings': 'SET',
  'me_system.logout': 'OUT',
};

const ME_PNG = '/brand/me/png';

/** 资产变换 — order matches prod 個人中心 reference (3×5 grid). */
export const ME_ASSET_ITEM_DEFS: MeItemDef[] = [
  { key: 'me_asset.sell_uo', icon: `${ME_PNG}/asset1.png`, to: '/sell-uo' },
  { key: 'me_asset.mp_to_uo', icon: `${ME_PNG}/asset2.png`, to: '/convert/mp-orb' },
  { key: 'me_asset.ep_to_rp', icon: `${ME_PNG}/asset3.png`, to: '/convert?from=ep&to=rp' },
  { key: 'me_asset.ep1_to_ep', icon: `${ME_PNG}/asset4.png`, to: '/convert?from=ep1&to=ep' },
  { key: 'me_asset.ep2_to_ep', icon: `${ME_PNG}/asset4.png`, to: '/convert?from=ep2&to=ep' },
  { key: 'me_asset.ep1_to_sp1', icon: `${ME_PNG}/asset5.png`, to: '/convert?from=ep1&to=sp1' },
  { key: 'me_asset.rp_to_sp3', icon: `${ME_PNG}/asset6.png`, to: '/convert/rp-sp3' },
  { key: 'me_asset.sp3_to_sp1', icon: `${ME_PNG}/asset7.png`, to: '/convert?from=sp3&to=sp1' },
  { key: 'me_asset.rp_withdraw', icon: `${ME_PNG}/asset9.png`, to: '/lineage-transfer/rp' },
  { key: 'me_asset.tp_withdraw', icon: `${ME_PNG}/asset10.png`, to: '/lineage-transfer/tp' },
  { key: 'me_asset.rp_tp_fc', icon: `${ME_PNG}/asset11.png`, to: '/lineage-transfer' },
  { key: 'me_asset.fp_withdraw', icon: `${ME_PNG}/asset12.png`, to: '/donations' },
  { key: 'me_asset.fc_withdraw', icon: `${ME_PNG}/asset13.png`, to: '/lineage-transfer/fc' },
  { key: 'me_asset.recharge_tp', icon: `${ME_PNG}/asset2.png`, to: '/recharge-tp' },
  { key: 'me_asset.static_usdt_payout', icon: `${ME_PNG}/asset10.png`, to: '/static-usdt-payout' },
  { key: 'me_asset.buy_fuel', icon: `${ME_PNG}/asset14.png`, to: '/buy-fuel' },
  { key: 'me_asset.recharge_rp', icon: `${ME_PNG}/asset9.png`, to: '/recharge-rp' },
];

/** 市场管理 — 子账户 / 附近 / 全球 (no ORB·EP trading shortcuts). */
export const ME_MARKET_ITEM_DEFS: MeItemDef[] = [
  { key: 'me_market.sub_accounts', icon: `${ME_PNG}/market2.png`, to: '/sub-accounts' },
  { key: 'me_market.nearby', icon: `${ME_PNG}/market3.png`, to: '/nearby' },
  { key: 'me_market.all_users', icon: `${ME_PNG}/market4.png`, to: '/all-users' },
  { key: 'me_market.register_member', icon: `${ME_PNG}/market1.png`, to: '/register-member' },
];

/** 财务记录 — each tile opens a scoped ledger or dedicated record page. */
export const ME_FINANCE_ITEM_DEFS: MeItemDef[] = [
  { key: 'me_finance.ep_records', icon: `${ME_PNG}/asset3.png`, to: '/history?asset=ep' },
  { key: 'me_finance.ep1_records', icon: `${ME_PNG}/asset4.png`, to: '/history?asset=ep1' },
  { key: 'me_finance.ep2_records', icon: `${ME_PNG}/asset4.png`, to: '/history?asset=ep2' },
  { key: 'me_finance.rp_records', icon: `${ME_PNG}/asset9.png`, to: '/history?asset=rp' },
  { key: 'me_finance.sp1_records', icon: `${ME_PNG}/asset5.png`, to: '/history?asset=sp1' },
  { key: 'me_finance.sp3_records', icon: `${ME_PNG}/asset6.png`, to: '/history?asset=sp3' },
  { key: 'me_finance.mp_records', icon: `${ME_PNG}/asset2.png`, to: '/history?asset=mp' },
  { key: 'me_finance.fp_records', icon: `${ME_PNG}/record1.png`, to: '/history?asset=fp' },
  { key: 'me_finance.tp_records', icon: `${ME_PNG}/record2.png`, to: '/history?asset=tp' },
  { key: 'me_finance.uo_records', icon: `${ME_PNG}/record3.png`, to: '/history?asset=uo' },
  { key: 'me_finance.fc_records', icon: `${ME_PNG}/record4.png`, to: '/history?asset=fc' },
  { key: 'me_finance.income_details', icon: `${ME_PNG}/record5.png`, to: '/income-details' },
  { key: 'me_finance.ep_purchase_records', icon: `${ME_PNG}/record6.png`, to: '/history?action=ep_trade' },
  { key: 'me_finance.fork_records', icon: `${ME_PNG}/record7.png`, to: '/fork-records' },
  { key: 'me_finance.donate', icon: `${ME_PNG}/record8.png`, to: '/donations' },
  { key: 'me_finance.imputation', icon: `${ME_PNG}/record9.png`, to: '/imputation' },
];

/** 系统设置 — 汇率换算 / 设置 / 退出 */
export const ME_SYSTEM_ITEM_DEFS: MeItemDef[] = [
  { key: 'me_system.exchange_calc', icon: `${ME_PNG}/system1.png`, to: '/exchange-calc' },
  { key: 'me_system.feedback', icon: `${ME_PNG}/system1.png`, to: '/tickets' },
  { key: 'me_system.settings', icon: `${ME_PNG}/system6.png`, to: '/setting' },
  { key: 'me_system.logout', color: ME_ITEM_COLORS.red, icon: `${ME_PNG}/system7.png`, isLogout: true },
];

/* --- From wallet.ts --- */
export { TOKEN_ICON_IMAGES } from './icons';
export { WALLET_FEATURES } from './common';

export const WALLET_COLORS = {
  logoText: THEME_COLORS.walletLogoText,
  border: THEME_COLORS.border,
  gold: THEME_COLORS.gold,
  text: THEME_COLORS.text,
  muted: THEME_COLORS.muted,
  bgGlass: THEME_COLORS.glassBg,
  shadowGlass: SHADOWS.otherShadow,
  actionDivider: THEME_COLORS.actionDivider,
  iconBorder: THEME_COLORS.border,
  bgIcon: 'rgba(0, 0, 0, 0.25)',
  iconShadow: SHADOWS.iconShadow,
  otherShadow: SHADOWS.otherShadow,
  bgFeature: 'rgba(11, 20, 20, 0.40)',
  featureShadow: SHADOWS.featureShadow,
  arrowKey: THEME_COLORS.activeGreen,
  chartColor: THEME_COLORS.chartColor,
  bgAsset: 'rgba(1, 5, 17, 0.10)',
  shadowAsset: SHADOWS.assetShadow,
  otherAsset: 'rgba(246, 205, 81, 0.3)',
} as const;

export const MOCK_BALANCES: Record<string, string> = {
  uo: '11,645',
  uo_sell: '0',
  fp: '1.940',
  uo_total: '11,645',
  tp: '0.000',
  rp: '0.000',
  ep: '0.000',
  ep1: '0.000',
  ep2: '0.000',
  sp1: '868.570',
  sp2: '124.680',
  sp3: '0.000',
  ap: '0',
  ap_queue: '0.000',
  mp: '0.000',
  uoc: '0.000',
  activation: '0.000',
  fc: '0.000',
  yesterday_perf: '0',
  today_perf: '0',
  consensus_pool: '1,895,148,292',
  fork_pool: '198,458,579',
};

export const BALANCE_CELL_KEYS = [
  'uo',
  'uo_sell',
  'fp',
  'uo_total',
  'tp',
  'rp',
  'ep',
  'ep1',
  'ep2',
  'sp1',
  'sp3',
  'ap',
  'ap_queue',
  'mp',
  'fc',
] as const;

export const CONTRACT_ITEMS = [
  { labelKey: 'wallet.contract_consensus', key: 'consensus_pool', fallback: undefined },
  { labelKey: 'wallet.contract_fork', key: 'fork_pool', fallback: undefined },
  { labelKey: 'wallet.contract_burn', key: 'burn_pool', fallback: undefined },
  { labelKey: 'wallet.contract_seed', key: 'seed_pool', fallback: undefined },
  { labelKey: 'wallet.contract_exchange_reserve', key: 'exchange_reserve', fallback: undefined },
] as const;

export const UO_ASSET_STATS = [
  { labelKey: 'wallet.uoAssetPackage', balanceKey: 'uo_asset_package', fallback: '$1,000' },
  { labelKey: 'wallet.uoAssetQty', balanceKey: 'uo_asset_qty', fallback: '0' },
  { labelKey: 'wallet.uoAssetFork', balanceKey: 'uo_asset_fork_value', fallback: '$4,000.180' },
] as const;

/* --- From history.ts --- */
export const HISTORY_COLORS = {
  ...THEME_COLORS,
  ...INTERACTIVE_COLORS,
  positive: STATUS_COLORS.success,
  negative: STATUS_COLORS.error,
  gold: STATUS_COLORS.warning,
  arrow: STATUS_COLORS.green,
  dropdownShadow: SHADOWS.dropdownShadow,
} as const;

/* --- From cashflow.ts --- */
export const CASHFLOW_COLORS = {
  ...THEME_COLORS,
  positive: STATUS_COLORS.successAlt,
  green: STATUS_COLORS.green,
  blue: STATUS_COLORS.blue,
  red: STATUS_COLORS.error,
} as const;

/* --- From inbox.ts --- */
export const INBOX_COLORS = {
  ...THEME_COLORS,
  gold: STATUS_COLORS.warning,
  green: STATUS_COLORS.green,
} as const;
